/**
 * @package Bears Lookbook
 * @author Bearsthemes
 * 
 */

import blookbook_tippy from 'tippy.js';
import blookbook_furygrid from './furygrid/jquery.furygrid';
import blookbook_lightbox_quickview from './modules-js/blookbook-lightbox-quickview.js';

!(function(w, $) {
    'use strict';

    /* Blookbook global object */
    w.blookbook_global = {
        furygrid: [],
    };

    var blookbook_image_lazy_load_func = function() {
        $('img[data-blookbook-lazy-load-image]').each(function() {
            var $image = $(this);
            var src = $image.data('blookbook-lazy-load-image');
            if(! src) return;

            var _img = new Image();

            _img.onload = function() {
                $image.attr( 'src', src );
                $image.removeAttr('srcset');
            }
            _img.src = src;
        })
    }

    var blookbook_tippyjs_func = function( $selector_wrapper ) {
        var $select_element = ( $selector_wrapper ) ? $selector_wrapper.find( '[data-blookbook-tippyjs]' ) : $('[data-blookbook-tippyjs]');
        
        $select_element.each(function() {
            var $this = $(this);
            var html_template = false;
            var opts = $.extend({

            }, $this.data('blookbook-tippyjs'));

            if( $this.find('[data-blookbook-tooltip-template]').length > 0 ) {
                html_template = true;
            }

            if( true == html_template ) {
                opts.html = $this.find('[data-blookbook-tooltip-template]')[0];
            }
            
            blookbook_tippy( this, opts )
        })
    }

    var blookbook_furygrid_func = function() {
        $('[data-blookbook-furygrid]').each(function() {
            var $this = $(this);
            var opts = $.extend({
                El: this,
            }, $this.data('blookbook-furygrid'))

            var grid_obj = new blookbook_furygrid( opts );
            $this.data('furygrid-obj', grid_obj);

            w.blookbook_global.furygrid.push( grid_obj );
        })
    }

    $( () => {
        /* call api */
        blookbook_tippyjs_func();
        blookbook_furygrid_func();
        blookbook_image_lazy_load_func();

        /* DOM Ready */
        $('*[data-lookbook-lightbox-quickview]').each( function() {
            var $el_obj = new blookbook_lightbox_quickview( $(this), {
                on_ajax_success_callback ( $el, ajax_res, $modal ) {
                    blookbook_tippyjs_func( $modal.find( '.blookbook-modal-body' ) );
                    blookbook_image_lazy_load_func();
                },
            } );
        } )
    } );

    $(w).load( () => {

    } )

})(window, jQuery) 